module.exports = __webpack_public_path__ + "static/media/komunitas_robot_logo.b1a19402.png";